import { IconBase, type IconProps } from './IconBase';

/**
 * CalendarioIcon — calendario simple.
 *
 * Simbolo: cita, agenda, planificacion.
 *
 * Composicion:
 * - Marco exterior (rect con esquinas redondeadas) que representa la
 *   hoja del mes.
 * - Linea horizontal superior que separa la cabecera (donde van los
 *   dias de semana) del cuerpo.
 * - Dos "anillas" superiores que sugieren las espirales o ganchos
 *   tipicos de un calendario fisico.
 * - Tres puntos / cuadrados internos representando dias resaltados —
 *   reforzando la idea de "fechas".
 */
export function CalendarioIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      {/* Marco principal */}
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      {/* Cabecera separada */}
      <path d="M3.5 9.5 L 20.5 9.5" />
      {/* Anillas */}
      <path d="M8 3.5 L 8 6.5" />
      <path d="M16 3.5 L 16 6.5" />
      {/* Dias destacados (tres cuadritos internos) */}
      <rect x="7" y="12.5" width="2" height="2" />
      <rect x="11" y="12.5" width="2" height="2" />
      <rect x="15" y="12.5" width="2" height="2" />
      <rect x="7" y="16.5" width="2" height="2" />
    </IconBase>
  );
}
